// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__eQho0","main-props-container":"style_main-props-container__2Bgxu","info-container":"style_info-container__1-qCa"};